import { render, staticRenderFns } from "./ArticleSearch.vue?vue&type=template&id=f1096526&scoped=true&"
import script from "./ArticleSearch.vue?vue&type=script&lang=ts&"
export * from "./ArticleSearch.vue?vue&type=script&lang=ts&"
import style0 from "./ArticleSearch.vue?vue&type=style&index=0&id=f1096526&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1096526",
  null
  
)

export default component.exports